export default __webpack_public_path__ + "static/media/allergy.efcf115b.svg";